import { useQuery } from "@tanstack/react-query";
import { commimentsExposure } from "../api/commimentsExposure";
import { CommitmentStateData } from "../types";

export const useCommitmentsStates = () => {

    const { data, isLoading, isError, error, isSuccess } = useQuery({
        queryKey: ["commitments-exposure-states"],
        queryFn: () => commimentsExposure.getCommimentsExposureStateData(),
    });

    return { data: data as CommitmentStateData, isLoading, isError, error };

};